import { render, staticRenderFns } from "./premium-transparent1.vue?vue&type=template&id=ba3aed0a&scoped=true"
import script from "./premium-transparent1.vue?vue&type=script&lang=js"
export * from "./premium-transparent1.vue?vue&type=script&lang=js"
import style0 from "./premium-transparent1.vue?vue&type=style&index=0&id=ba3aed0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3aed0a",
  null
  
)

export default component.exports